import React, { Component } from 'react'
import './modal-preview.css'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import {
	Modal,
	Container,
	Row,
	Col,
} from 'react-bootstrap'

const PLACEHOLDER_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 600 400'%3E%3Crect width='600' height='400' fill='%23e9ecef'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='16' fill='%236c757d'%3EImagem indispon%C3%ADvel%3C/text%3E%3C/svg%3E"

class MediaCenterModalPreview extends Component {
	constructor(props) {
		super(props)

		this.state = {
			show_preview: false,
		}
	}

	componentDidMount() {

	}

	render() {
		const { use_logo, logo } = this.props

		return (
			<div className="media-preview">
				<Modal
					show={this.props.show_preview}
					onHide={this.props.handleClosePreview}
					size="lg"
					aria-labelledby="contained-modal-title-vcenter"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							{this.props.nome}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Container>
							<Row>
								<Col sm={12} md={12}>

									<div className="media-center-preview">
										{(this.props.previewList && this.props.previewList.length > 0) && (
											<Carousel
												width='100%'
												showArrows={true}
												showStatus={false}
												showThumbs={false}
												showIndicators={true}
												infiniteLoop={true}
												emulateTouch={true}
												swipeable={true}
												{...this.props}
											>
												{this.props.previewList.map((item) => {
													return (
														<div>
															<img className="media-center-img-preview" src={'data:image/png;base64,' + `${item.base}`} alt="" onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMAGE }} />
														</div>
													)
												})}
											</Carousel>
										)}

										{(!this.props.previewList || (this.props.previewList && this.props.previewList.length == 0)) && (
											<img className="media-center-img-preview" src={this.props.url_preview || this.props.url_miniatura || PLACEHOLDER_IMAGE} alt="" onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMAGE }} />
										)}
									</div>

								</Col>
							</Row>
						</Container>
					</Modal.Body>
				</Modal>
			</div>
		)
	}
}

export default MediaCenterModalPreview
